import fundaNowClient from '@/client/fundaNowClient'
import qs from 'query-string'

export default {
  getQuestion(questionUuid) {
    return fundaNowClient.call({
      url: `/talks/questions/${questionUuid}`,
      method: 'GET',
    })
  },
  getQuestions(param) {
    return fundaNowClient.call({
      url: `/talks/questions/?${qs.stringify(param)}`,
      method: 'GET',
    })
  },
  getFixedQuestion() {
    return fundaNowClient.call({
      url: '/talks/questions/',
      method: 'GET',
      params: {
        is_banner_talk: true,
      },
    })
  },
  likeQuestion(question) {
    return fundaNowClient.call({
      url: `/talks/questions/${question.uuid}/like/`,
      method: 'POST'
    })
  },
  unlikeQuestion(question) {
    return fundaNowClient.call({
      url: `/talks/questions/${question.uuid}/unlike/`,
      method: 'POST'
    })
  },
  likeAnswer(answer) {
    return fundaNowClient.call({
      url: `/talks/answers/${answer.uuid}/like/`,
      method: 'POST'
    })
  },
  unlikeAnswer(answer) {
    return fundaNowClient.call({
      url: `/talks/answers/${answer.uuid}/unlike/`,
      method: 'POST'
    })
  }
}
